module.exports = __webpack_public_path__ + "static/media/js5.80ba0d0b.PNG";